function getPageSizes(): number[] {
  return [10, 20, 50, 100];
}

export const paginationHelper = {
  getPageSizes,
}